import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surveillance',
  templateUrl: './surveillance.component.html',
  styleUrls: ['./surveillance.component.scss']
})
export class SurveillanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
